import './App.css';
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Login from './Components/Screens/Login/Login.jsx';
import ProtectedRoute from './Components/Protected Route/ProtectedRoute';
import RoleBasedRoute from './Components/Protected Route/RoleBased';
import InternalServerError from "./Components/Errors Handling/Error 500/InternalServerError.jsx";
import Error404 from "./Components/Errors Handling/Error 404/Error404.jsx";
import Layout from './Components/layout/Layout.jsx';
import Dashboard from './Components/Screens/Dashboard/Dashboard.jsx';
import Clinics from './Components/Screens/Clinics/Clinics.jsx';
import WorkingDaysPage from './Components/Screens/WorkingDays/WorkingDays.jsx';
import CreateBookingForm from './Components/Screens/BookingForm/CreateBookingForm.jsx';
import BookingsScreen from './Components/Screens/BookingsScreen/BookingsScreen.jsx';
import Insights from './Components/Screens/Insights/Insights.jsx';
import PatientsList from './Components/Screens/PatientsList/PatientsList.jsx';
import PatientDetails from './Components/Screens/PatientDetails/PatientDetails.jsx';
import ServicesManager from './Components/Screens/Services/Services.jsx';
import BlogsScreen from './Components/Screens/BlogsScreen/BlogsScreen.jsx';
import PackagesManagement from './Components/Screens/PackagesScreen/PackageScreen.jsx';
import { UserSubscription } from './Components/Screens/Plans/Plans.jsx';
import CurrentActivePatent from './Components/Screens/CurrentActivePatient/CurrentActivePatient.jsx';
import SpecialistPatientScreen from './Components/Screens/CommingPatient/CommingPatient.jsx';
import SpecialistBookingsScreen from './Components/Screens/SessionsScreen/SessionsScreen';
import QrScanner from './Components/Screens/QrScanner/QrScanner.jsx';

function App() {
  const routers = createBrowserRouter([
    { index: true, element: <Login /> },
    { path: "login", element: <Login /> },

    {
      path: '/', 
      element: <ProtectedRoute><Layout /></ProtectedRoute>,
      children: [
        { 
          path: 'dashboard', 
          element: (
            <RoleBasedRoute allowedRoles={[2]}>
              <Dashboard />
            </RoleBasedRoute>
          )
        },
        { 
          path: 'clinics', 
          element: (
            <RoleBasedRoute allowedRoles={[2]}>
              <Clinics />
            </RoleBasedRoute>
          )
        },
        
        // Role 2 (Doctor) only routes
        // { 
        //   path: 'insights', 
        //   element: (
        //     <RoleBasedRoute allowedRoles={[2]}>
        //       <Insights />
        //     </RoleBasedRoute>
        //   )
        // },
        { 
          path: 'schedule', 
          element: (
            <RoleBasedRoute allowedRoles={[2]}>
              <WorkingDaysPage />
            </RoleBasedRoute>
          )
        },
        { 
          path: 'form-builder', 
          element: (
            <RoleBasedRoute allowedRoles={[2]}>
              <CreateBookingForm />
            </RoleBasedRoute>
          )
        },
        { 
          path: 'active-patient', 
          element: (
            <RoleBasedRoute allowedRoles={[2]}>
              <CurrentActivePatent />
            </RoleBasedRoute>
          )
        },
        { 
          path: 'comming-patient', 
          element: (
            <RoleBasedRoute allowedRoles={[5]}>
              <SpecialistPatientScreen />
            </RoleBasedRoute>
          )
        },
        { 
          path: 'bookings', 
          element: (
            <RoleBasedRoute allowedRoles={[2]}>
              <BookingsScreen />
            </RoleBasedRoute>
          )
        },
        // { 
        //   path: 'Services', 
        //   element: (
        //     <RoleBasedRoute allowedRoles={[2]}>
        //       <ServicesManager />
        //     </RoleBasedRoute>
        //   )
        // },
        // { 
        //   path: 'Blogs', 
        //   element: (
        //     <RoleBasedRoute allowedRoles={[2]}>
        //       <BlogsScreen />
        //     </RoleBasedRoute>
        //   )
        // },
        // { 
        //   path: 'packages', 
        //   element: (
        //     <RoleBasedRoute allowedRoles={[2]}>
        //       <PackagesManagement />
        //     </RoleBasedRoute>
        //   )
        // },
        { 
          path: 'sessions', 
          element: (
            <RoleBasedRoute allowedRoles={[2,5]}>
              <SpecialistBookingsScreen />
            </RoleBasedRoute>
          )
        },
        { 
          path: 'scanQr', 
          element: (
            <RoleBasedRoute allowedRoles={[2,5]}>
              <QrScanner />
            </RoleBasedRoute>
          )
        },
        { 
          path: 'sub', 
          element: (
            <RoleBasedRoute allowedRoles={[2]}>
              <UserSubscription />
            </RoleBasedRoute>
          )
        },
        
        { 
          path: 'patients', 
          element: (
            <RoleBasedRoute allowedRoles={[2,5]}>
              <PatientsList />
            </RoleBasedRoute>
          )
        },
        { 
          path: 'patients/:id', 
          element: (
            <RoleBasedRoute allowedRoles={[2,5]}>
              <PatientDetails />
            </RoleBasedRoute>
          )
        },

        // Error routes - accessible by all authenticated users
        { path: 'server-error', element: <InternalServerError /> },
        { path: 'not-found', element: <Error404 /> },
        { path: '*', element: <Error404 /> }
      ]
    },
  ]);

  return <RouterProvider router={routers} />;
}

export default App;